module.exports = __webpack_public_path__ + "img/finland-blood-diseases-female.c0097bad.png";